export const forBusiness_graphics_engage = [
	{
		icon: '🔹',
		subtitle: 'engageData_subtitle1',
	},
	{
		icon: '🔹',
		subtitle: 'engageData_subtitle2',
	},
	{
		icon: '🔹',
		subtitle: 'engageData_subtitle3',
	},
];
